import { func, string, bool, array, oneOfType } from "prop-types"
import TimePicker from "components/ui/TimePicker"
import { StackView } from "@planningcenter/tapestry-react"
import RegistrationsThemeProvider from "components/admin/registrations_theme_provider"

const TimeRange = props => {
  const { startsAt, endsAt, onChangeStartsAt, onChangeEndsAt } = props

  return (
    <RegistrationsThemeProvider>
      <StackView
        css={{ flex: "auto" }}
        axis="horizontal"
        alignment="center"
        flex="1"
        spacing={1}
        mediaQueries={{ sm: { paddingLeft: 1 } }}
      >
        <TimePicker
          datetime={startsAt}
          mobileBrowser={window.isMobile}
          onChange={onChangeStartsAt}
          {...props}
        />
        <span>to</span>
        <TimePicker
          datetime={endsAt}
          mobileBrowser={window.isMobile}
          onChange={onChangeEndsAt}
          {...props}
        />
      </StackView>
    </RegistrationsThemeProvider>
  )
}

TimeRange.defaultProps = {
  onChangeStartsAt: () => {},
  onChangeEndsAt: () => {}
}

TimeRange.propTypes = {
  id: string,
  classNames: oneOfType([string, array]),
  style: string,
  onChangeStartsAt: func,
  onChangeEndsAt: func,
  name: string,
  twentyFourHourTime: bool.isRequired,
  startsAt: string.isRequired,
  endsAt: string.isRequired
}

export default TimeRange
